import axiosService from '@services/axiosService';

export const getAvailableLanguagesList = (token) =>
  axiosService.get('/api/TranscriptEntries/list-available-languages', {
    params: {
      access_token: token,
    },
  });



// WEBPACK FOOTER //
// ./services/trscService.js